import { styled } from '@nykaa/ui-components';

export const Switch = styled.div`
  width: fit-content;
  position: absolute;
  top: 5px;
  right: 5px;
  ${({ theme }) => theme.typography.labelMedium};
  padding: 0;
`;

export const SliderButton = styled.div`
  flex: 1;
  padding: 7px 0 7px 0;
  width: 44px;
  text-align: center;
  z-index: 1;
`;

export const Slider = styled.div<{ toggle: boolean }>`
  background: ${({ theme }) => theme.colors.secondary10};
  position: absolute;
  width: 50%;
  height: 100%;
  z-index: 0;
  left: ${({ toggle }) => (toggle ? `50%` : `0%`)};
  border-radius: 1px;
  transition: left 0.1s ease;
`;

export const SliderContainer = styled.span`
  color: #fd7685;
  display: flex;
`;
